const SwishPaymentStatus = {
  PAID: 'PAID',
  FAILED: 'ERROR',
  DECLINED: 'DECLINED',
  NEW: 'NEW',
};
export default SwishPaymentStatus;
